// extracted by mini-css-extract-plugin
export var modal = "_5l-0";